import React, { useMemo } from 'react';
import { Box, Circle, Inscription} from '@common-fe/common-fe';

import { Roles } from '@/common/constants';

interface Props {
  role?: Roles;
  isWelcomeEmailSent?: boolean;
}

const UserStatus: React.FC<Props> = ({ role, isWelcomeEmailSent }) => {
  const isRegistered = useMemo(() => role === Roles.employee || role === Roles.limitedAccess, [role]);

  const userStatusTitle = useMemo(() => {
    if (isRegistered) {
      return 'Registered';
    }

    if (isWelcomeEmailSent) {
      return 'Not registered (Welcome email sent)';
    }

    return 'Not registered (Welcome email not sent)';
  }, [isRegistered, isWelcomeEmailSent]);
  
  return (
    <Box direction="row" align="center">
      <Circle
        data-testId="user-verification-status-form_user-status-circle"
        status={isRegistered ? 'registered_user' : 'not_registered_user'}
      />
      <Inscription data-testId="user-verification-status-form_user-status-title" margin={{ left: 'spacing8' }}>
        {userStatusTitle}
      </Inscription>
    </Box>
  );
};

export default UserStatus;
